import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightLong,faArrowLeft } from "@fortawesome/free-solid-svg-icons";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useForm } from 'react-hook-form';

const AjouterPage = (props) => {
    const token = localStorage.getItem("JWT");

    const [load, setLoad] = useState("");           // Gestion du UseEffect
    const [ongletSwitch, setOngletSwitch] = useState(0);           // Gestion Du menu Ajouter
    const [allRangs, setAllRangs] = useState([]);           // recuperation des rangs
    const [allRoles, setAllRoles] = useState([]);           // recuperation des rôles
    const [allEncadrements, setAllEncadrements] = useState([]);           // recuperation des encadrants
    const [allDivisions, setAllDivisions] = useState([]);           // recuperation des divisions actives

    const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm(    // declaration du formulaire et des fonctions nécessaire
        {
            defaultValues: {
                //warbond
                valeur: "",
                prix: "",
                disponible: true,

                //rang
                nomRang: "",
                prioriteRang: "",
                lienRang: "",
                discordIDRang: "",

                //encadrement
                nomEncadrant: "",
                discordIDEncadrant: "",
                prioriteEncadrant: "",

                //divisions actives
                nomDivision: "",
                discordIDDivision: "",
                prioriteDivision: "",

                //carte,avatar,cadre
                hashtag: '',
                rarete: '',
                nom: '',
                aquisition: '',
                description: '',
                prix: '',
                image: '',
                disponible: true,
            }
        }

    );

    //----------------------------------------------------get all data-----------------------------------------------//

    function getAllRangs(e) {    // Recupere tout les rangs

        axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}api/allRangs`,
            headers: {
                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
            },
        })
            .then((res) => {
                setAllRangs(res.data)
            })
            .catch((err) => {
            })

    }

    function getAllDivisions(e) {    // Recupere tout les rangs

        axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}api/allDivisions`,
            headers: {
                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
            },
        })
            .then((res) => {
                setAllDivisions(res.data)
            })
            .catch((err) => {
            })

    }

    function getAllEncadrement(e) {    // Recupere tout les rangs

        axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}api/allEncadrements`,
            headers: {
                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
            },
        })
            .then((res) => {
                setAllEncadrements(res.data)
            })
            .catch((err) => {
            })

    }

    //----------------------------------------------------Post all data-----------------------------------------------//

    const addRang = data => {    // Ajouter un rang a la BDD

        let nom = document.getElementById("nomRang").value;
        let priorite = document.getElementById("prioriteRang").value;
        let image = data.lienRang[0];
        let discordID = data.discordIDRang;

        axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}api/addRang`,
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
            },
            data: {
                nom,
                priorite,
                image,
                discordID,
            }
        })
            .then((res) => {
                reset()
                setLoad(res)
                toast.success("Rang ajouté avec succès!");
                console.log(res);
            })
            .catch((err) => {
                toast.error("Erreur d'ajout du rang!");
                console.log(err);
            })

    }

    const addEncadrement = data => {    // Ajouter un statut d'encadrant a la BDD

        let nom = document.getElementById("nomEncadrant").value;
        let priorite = document.getElementById("prioriteEncadrant").value;
        let discordID = data.discordIDEncadrant;

        axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}api/addEncadrement`,
            headers: {
                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
            },
            data: {
                nom,
                priorite,
                discordID,
            }
        })
            .then((res) => {
                reset()
                setLoad(res)
                toast.success("Encadrant ajouté avec succès!");
                console.log(res);
            })
            .catch((err) => {
                toast.error("Erreur d'ajout du statut d'encadrement!");
                console.log(err);
            })

    }

    const addDivision = data => {    // Ajouter un statut d'encadrant a la BDD

        let nom = document.getElementById("nomDivision").value;
        let priorite = document.getElementById("prioriteDivision").value;
        let discordID = data.discordIDDivision;

        axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}api/addDivisions`,
            headers: {
                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
            },
            data: {
                nom,
                priorite,
                discordID,
            }
        })
            .then((res) => {
                reset()
                setLoad(res)
                toast.success("Division ajouté avec succès!");
                console.log(res);
            })
            .catch((err) => {
                toast.error("Erreur d'ajout de la division!");
                console.log(err);
            })

    }

    function addWarbonds(e) {    // Ajouter un warbonds pack

        let valeur = document.getElementById("valeurWarbonds").value;
        let prix = document.getElementById("prixWarbonds").value;
        let disponible = document.getElementById("disponibleWarbonds").checked;

        axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}api/addWarbonds`,
            headers: {
                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
            },
            data: {
                valeur,
                prix,
                disponible,
            }
        })
            .then((res) => {
                toast.success("Warbond pack ajouté avec succès!");
                console.log(res);
                reset()
            })
            .catch((err) => {
                toast.error("Erreur d'ajout du pack!");
                console.log(err);
            })

    }

    const addMedia = data => {    // Ajouter un media dans la BDD

        let hashtag = data.hashtag
        let nom = data.nom
        let description = data.description
        let rarete = data.rarete
        let prix = data.prix
        let aquisition = data.aquisition
        let disponible = data.disponible
        let image = data.image[0]

        // console.log(hashtag);
        // console.log(nom);
        // console.log(description);
        // console.log(rarete);
        // console.log(prix);
        // console.log(aquisition);
        // console.log(disponible);
        // console.log(image);

        switch (ongletSwitch) {
            case 1:
                axios({
                    method: "post",
                    url: `${process.env.REACT_APP_API_URL}api/addCarte`,
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                    },
                    data: {
                        hashtag,
                        nom,
                        description,
                        rarete,
                        prix,
                        image,
                        aquisition,
                        disponible,
                    }
                })
                    .then((res) => {
                        toast.success("Carte ajouté avec succès!");
                        reset()
                    })
                    .catch((err) => {
                        console.log(err);
                        toast.success(err.response.data.message);
                    })
                break;

            case 2:
                axios({
                    method: "post",
                    url: `${process.env.REACT_APP_API_URL}api/addAvatar`,
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                    },
                    data: {
                        hashtag,
                        nom,
                        description,
                        rarete,
                        prix,
                        image,
                        aquisition,
                        disponible,
                    }
                })
                    .then((res) => {
                        toast.success("Avatar ajouté avec succès!");
                        reset()
                    })
                    .catch((err) => {
                        console.log(err);
                        toast.success(err.response.data.message);
                    })
                break;

            case 3:
                axios({
                    method: "post",
                    url: `${process.env.REACT_APP_API_URL}api/addCadre`,
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                    },
                    data: {
                        hashtag,
                        nom,
                        description,
                        rarete,
                        prix,
                        image,
                        aquisition,
                        disponible,
                    }
                })
                    .then((res) => {
                        toast.success("Cadre ajouté avec succès!");
                        reset()
                    })
                    .catch((err) => {
                        console.log(err);
                        toast.success(err.response.data.message);
                    })
                break;

            default:
                break;
        }
        // e.preventDefault();

        // let hashtag = document.getElementById("hashtag").value;
        // let nom = document.getElementById("nom").value;
        // let description = document.getElementById("description").value;
        // let prix = document.getElementById("prix").value;
        // let image = document.getElementById("lien").files[0];
        // let disponible = document.getElementById("disponible").checked;

        // axios({
        //     method: "post",
        //     url: `${process.env.REACT_APP_API_URL}api/addCarte`,
        //     headers: {
        //         "Content-Type": "multipart/form-data",
        //     },
        //     data: {
        //         hashtag,
        //         nom,
        //         description,
        //         rarete,
        //         prix,
        //         image,
        //         aquisition,
        //         disponible,
        //     }
        // })
        //     .then((res) => {
        //         console.log(res);
        //         let focusErrorMessage = document.getElementById("carteErrorMessage")
        //         focusErrorMessage.innerHTML = res.data.message
        //         setTimeout(() => {
        //             focusErrorMessage.innerHTML = "";
        //         }, 3000);

        //         setFormValues({
        //             hashtag: '',
        //             nom: '',
        //             description: '',
        //             prix: '',
        //             lien: '',
        //             disponible: false,
        //         });
        //         setRarete("")
        //         setAquisition("")
        //         setDisponible(true);
        //         document.getElementById("lien").value = "";
        //     })
        //     .catch((err) => {
        //         console.log(err);
        //         let focusErrorMessage = document.getElementById("carteErrorMessage")
        //         focusErrorMessage.innerHTML = err.response.data.message
        //         setTimeout(() => {
        //             focusErrorMessage.innerHTML = "";
        //         }, 3000);
        //     })

    }

    //----------------------------------------------------Autre-----------------------------------------------//

    function navigation(e) {       // gestion du menu

        let focusNewAgendaButton = document.getElementById("cartes")
        let focusAgendaButton = document.getElementById("avatars")
        let focusAdminButton = document.getElementById("cadres")
        let focusRoleButton = document.getElementById("rang")
        let focusWarbondButton = document.getElementById("warbond")

        focusNewAgendaButton.classList.remove("customMenu");
        focusAgendaButton.classList.remove("customMenu");
        focusAdminButton.classList.remove("customMenu");
        focusRoleButton.classList.remove("customMenu");
        focusWarbondButton.classList.remove("customMenu");

        switch (e.target.innerText) {

            case "Cartes":
                setOngletSwitch(1)
                focusNewAgendaButton.classList.add("customMenu");
                break;

            case "Avatar":
                setOngletSwitch(2)
                focusAgendaButton.classList.add("customMenu");
                break;

            case "Cadres":
                setOngletSwitch(3)
                focusAdminButton.classList.add("customMenu");
                break;

            case "Roles et rangs":
                setOngletSwitch(4)
                focusRoleButton.classList.add("customMenu");
                break;

            case "Warbond pack":
                setOngletSwitch(5)
                focusWarbondButton.classList.add("customMenu");
                break;
            default:
        }
    }

    const generateContent = (ongletSwitch) => { // Generer le formulaire de modification suivant le filtre
        switch (ongletSwitch) {
            case 1:
            case 2:
            case 3:
                return <div className='ongletAjouter__container'>
                    <form className='ongletAjouter__container__addingInterface' onSubmit={handleSubmit(addMedia)}>
                        <h2>Ajouter {ongletSwitch === 1 && "une carte"} {ongletSwitch === 2 && "un avatar"} {ongletSwitch === 3 && "un cadre"}:</h2>
                        <div className='ongletAjouter__container__addingInterface__formMiddle'>
                            <div className='inputSection'>

                                <div className='textInputSection'>
                                    <label htmlFor="hashtag">Hashtag (si nécéssaire):</label>
                                    <input className='textInput' type="text" id="hashtag" name="hashtag" required {...register("hashtag")} />
                                </div>

                                <div className='textInputSection'>
                                    <fieldset>
                                        <legend>Rareté:</legend>
                                        <div>
                                            <input type="radio" id="Commune" name="rarete" value="Commune" required {...register("rarete")} />
                                            <label htmlFor="Commune">Commune</label>
                                        </div>

                                        <div>
                                            <input type="radio" id="Rare" name="rarete" value="Rare" {...register("rarete")} />
                                            <label htmlFor="Rare">Rare</label>
                                        </div>

                                        <div>
                                            <input type="radio" id="Epic" name="rarete" value="Epic" {...register("rarete")} />
                                            <label htmlFor="Epic">Epic</label>
                                        </div>

                                        <div>
                                            <input type="radio" id="Légendaire" name="rarete" value="Légendaire" {...register("rarete")} />
                                            <label htmlFor="Légendaire">Légendaire</label>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>

                            <div className='inputSection'>

                                <div className='textInputSection'>
                                    <label htmlFor="nom">Nom:</label>
                                    <input className='textInput' type="text" id="nom" name="nom" required {...register("nom")} />
                                </div>

                                <div className='textInputSection'>
                                    <fieldset>
                                        <legend>Aquisition:</legend>
                                        <div>
                                            <input type="radio" id="Boutique" name="aquisition" value="Boutique" required {...register("aquisition")} />
                                            <label htmlFor="Boutique">Boutique</label>
                                        </div>

                                        <div>
                                            <input type="radio" id="Event" name="aquisition" value="Event" {...register("aquisition")} />
                                            <label htmlFor="Event">Event</label>
                                        </div>

                                        <div>
                                            <input type="radio" id="Tournoi" name="aquisition" value="Tournoi" {...register("aquisition")} />
                                            <label htmlFor="Tournoi">Tournoi</label>
                                        </div>

                                        <div>
                                            <input type="radio" id="Gratuit" name="aquisition" value="Gratuit" {...register("aquisition")} />
                                            <label htmlFor="Gratuit">Gratuit</label>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>

                            <div className='inputSection'>
                                <div className='textInputSection'>
                                    <label htmlFor="description">Description:</label>
                                    <input className='descriptionInput' type="text" id="description" name="description" required {...register("description")} />
                                </div>
                                <div className='textInputSection'>
                                    <label htmlFor="prix">Prix:</label>
                                    <input className='textInput' type="number" id="prix" name="prix" required {...register("prix")} />
                                </div>
                            </div>
                        </div>
                        <div className='ongletAjouter__container__addingInterface__formBottom' >
                            <input type="file" id="lien" name="lien" accept="image/png, image/jpeg" required {...register("image")} />
                            <div>
                                <label htmlFor="disponible">Disponible à l'achat:</label>
                                <input type="checkbox" id="disponible" name="disponible" {...register("disponible")} />
                            </div>
                            <input className='validateButton' type="submit" value="Valider" />
                        </div>
                    </form>

                </div>
                    ;
            default:
                return null; // ou un message par défaut, si nécessaire
        }
    };



    useEffect(() => {
        getAllRangs()
        getAllEncadrement()
        getAllDivisions()
    }, [load]);

    return (

        <div className='ongletAjouter'>
            <Link className='exitButton' to="/profil"><FontAwesomeIcon icon={faArrowLeft} /></Link>

            <ToastContainer
                position="bottom-right"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="dark"
            />

            <div className='ongletAjouter__menu'>
                <button id='cartes' onClick={navigation}>Cartes</button>
                <button id='avatars' onClick={navigation}>Avatar</button>
                <button id='cadres' onClick={navigation}>Cadres</button>
                <button id='rang' onClick={navigation}>Roles et rangs</button>
                <button id='warbond' onClick={navigation}>Warbond pack</button>
            </div>

            {generateContent(ongletSwitch)}

            {ongletSwitch === 0 &&
                <div className='ongletAjouter__welcomeMessage'>
                    <h2>Que souhaitez vous ajouter dans la base de donnée?</h2>
                </div>
            }
            {ongletSwitch === 4 &&
                <div className='ongletAjouter__rangsAndRolesContainer'>
                    <div className='ongletAjouter__rangsAndRolesContainer__rangs'>
                        <div className='ongletAjouter__rangsAndRolesContainer__rangs__left'>
                            <h2>Ajouter un rang FCU</h2>
                            <form onSubmit={handleSubmit(addRang)}>
                                <span>
                                    <label htmlFor="nomRang">Nom du rang:</label>
                                    <input className='rangAndRoleInput' type="text" id="nomRang" name="nomRang" {...register("nomRang")} required />
                                </span>

                                <span>
                                    <label htmlFor="discordIDRang">DiscordID du rang:</label>
                                    <input className='rangAndRoleInput' type="text" id="discordIDRang" name="discordIDRang" {...register("discordIDRang")} required />
                                </span>

                                <span>
                                    <label htmlFor="prioriteRang">Priorité:</label>
                                    <input className='rangAndRoleInput' type="number" id="prioriteRang" name="prioriteRang" {...register("prioriteRang")} required />
                                </span>

                                <input type="file" id="lienRang" name="lien" accept="image/png, image/jpeg" {...register("lienRang")} required />

                                <input className='rangAndRoleSubmit' type="submit" value="Valider" />
                            </form>
                        </div>
                        <FontAwesomeIcon icon={faArrowRightLong} />
                        <div className='ongletAjouter__rangsAndRolesContainer__rangs__right'>
                            <h2>Rangs disponible:</h2>
                            <ul>
                                {allRangs.map((rangs) => (
                                    <li key={rangs.id}><p>{rangs.nom} - {rangs.priorite}</p></li>
                                ))}
                            </ul>
                        </div>

                    </div>
                
                    <div className='ongletAjouter__rangsAndRolesContainer__rangs'>
                        <div className='ongletAjouter__rangsAndRolesContainer__rangs__left'>
                            <h2>Ajouter un statut d'encadrement</h2>
                            <form onSubmit={handleSubmit(addEncadrement)}>
                                <span>
                                    <label htmlFor="nomEncadrant">Nom de l'encadrement:</label>
                                    <input className='rangAndRoleInput' type="text" id="nomEncadrant" name="nomEncadrant"{...register("nomEncadrant")} required />
                                </span>

                                <span>
                                    <label htmlFor="discordIDEncadrant">DiscordID du statut d'encadrement:</label>
                                    <input className='rangAndRoleInput' type="text" id="discordIDEncadrant" name="discordIDEncadrant" {...register("discordIDEncadrant")} required />
                                </span>
                                <span>
                                    <label htmlFor="prioriteEncadrant">Priorité:</label>
                                    <input className='rangAndRoleInput' type="number" id="prioriteEncadrant" name="prioriteEncadrant" {...register("prioriteEncadrant")} required />
                                </span>

                                <input className='rangAndRoleSubmit' type="submit" value="Valider" />
                            </form>
                        </div>
                        <FontAwesomeIcon icon={faArrowRightLong} />

                        <div className='ongletAjouter__rangsAndRolesContainer__rangs__right'>
                            <h2>Encadrements disponible:</h2>
                            <ul>
                                {allEncadrements.map((roles) => (
                                    <li key={roles.id}><p>{roles.nom} - {roles.priorite}</p></li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className='ongletAjouter__rangsAndRolesContainer__rangs'>
                        <div className='ongletAjouter__rangsAndRolesContainer__rangs__left'>
                            <h2>Ajouter une division active</h2>
                            <form onSubmit={handleSubmit(addDivision)}>
                                <span>
                                    <label htmlFor="nomDivision">Nom de l'encadrement:</label>
                                    <input className='rangAndRoleInput' type="text" id="nomDivision" name="nomDivision"{...register("nomDivision")} required />
                                </span>
                                <span>
                                    <label htmlFor="discordIDDivision">DiscordID de la division active:</label>
                                    <input className='rangAndRoleInput' type="text" id="discordIDDivision" name="discordIDDivision" {...register("discordIDDivision")} required />
                                </span>
                                <span>
                                    <label htmlFor="prioriteDivision">Priorité:</label>
                                    <input className='rangAndRoleInput' type="number" id="prioriteDivision" name="prioriteDivision" {...register("prioriteDivision")} required />
                                </span>

                                <input className='rangAndRoleSubmit' type="submit" value="Valider" />
                            </form>
                        </div>
                        <FontAwesomeIcon icon={faArrowRightLong} />

                        <div className='ongletAjouter__rangsAndRolesContainer__rangs__right'>
                            <h2>Divisions actives disponible:</h2>
                            <ul>
                                {allDivisions.map((roles) => (
                                    <li key={roles.id}><p>{roles.nom} - {roles.priorite}</p></li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            }

            {ongletSwitch === 5 &&
                <div className='ongletAjouter__warbondPack'>
                    <div className='ongletAjouter__warbondPack__container'>
                        <h1>Ajouter un warbond Pack</h1>
                        <form onSubmit={handleSubmit(addWarbonds)}>
                            <div className='ongletAjouter__warbondPack__container__top'>
                                <span>
                                    <label htmlFor="valeur">Valeur du pack</label>
                                    <input className='warbondInput' type="number" id="valeurWarbonds" name="valeur" {...register("valeur")} required />

                                </span>
                                <span>
                                    <label htmlFor="prix">Prix du pack</label>
                                    <input className='warbondInput' type="number" id="prixWarbonds" name="prix" {...register("prix")} required />
                                </span>
                                <span>
                                    <label htmlFor="disponible">Disponible a l'achat?</label>
                                    <input className='warbondInput' type="checkbox" id="disponibleWarbonds" name="disponible" {...register("disponible")} />
                                </span>
                            </div>

                            <input className='warbondSubmit' type="submit" value="Valider" />
                        </form>
                    </div>
                </div>


            }

        </div>
    );
};

export default AjouterPage;